import React from "react";
import messages from "./generic-error-messages";
import AppError from "../app-error";
import { injectIntl, FormattedMessage } from "react-intl";

import { EBSCO_URLS } from "../../../constants";

const GenericError = ({ intl }) => {
  return (
    <AppError
      title={intl.formatMessage(messages.genericErrorTitle)}
      description={intl.formatMessage(messages.genericErrorDescription)}
    >
      <FormattedMessage
        {...messages.genericErrorMessage}
        values={{
          a: displayHelpLink()
        }}
      />
    </AppError>
  );
};

const displayHelpLink = () => msg => (
  <a href={EBSCO_URLS.HELP_URL} target="_blank" rel="noopener noreferrer">
    {msg}
  </a>
);

export { GenericError };
export default injectIntl(GenericError);
